import { defineComponent, ref } from 'vue'

import PointPage from '@/organizations/_default/point'
import ProductModal from '@/organizations/glico-sunao/default/components/ProductModal.vue'
import FilterInfo from '@/organizations/glico-sunao/default/components/FilterInfo.vue'

export default defineComponent({
  extends: PointPage,
  components: {
    ProductModal,
    FilterInfo
  },
  setup(props, context) {
    const page = PointPage.setup(props, context)

    /**
     * クリックしたフィルターを保持
     *
     * 商品モーダルに以下のプロパティを使用
     * filter.name: 商品名(既存)
     * filter.image.url: 商品画像のURL(既存)
     * filter.extra_fields.product_description: 商品説明(追加)
     * filter.extra_fields.product_url: 商品詳細ページのURL(追加)
     * NOTE: 商品詳細ページのURLは既存のfilter.urlを使用しない
     *       このプロパティにURLを格納すると、店舗ページのフィルターがリンクとして機能してしまうため、モーダル用に新たなプロパティに保持
     */
    const selectedProduct = ref({})
    const modalRef = ref(null)

    const onClickedSearchCondition = (searchCondition) => {
      selectedProduct.value = searchCondition
      modalRef.value.open()
    }

    // ==============================
    // WDD イベント対応
    // 固定メッセージを追加フィールドの内容で上書き
    // ウォークラリー店舗にイベント用のメッセージを表示する
    // ==============================
    const EXTRA_FIELDS_MESSAGE = "message"
    const overrideMessage = page.point.value.extra_fields?.[EXTRA_FIELDS_MESSAGE]
    if (overrideMessage) {
      page.persistentMessage.value.message = overrideMessage
    }

    return {
      ...page,
      selectedProduct,
      modalRef,
      onClickedSearchCondition
    }
  }
})
